
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("iLXzZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $af8b3c3130098533$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $9hBKJ = parcelRequire("9hBKJ");
class $af8b3c3130098533$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    render() {
        const { children: children, localId: localId } = this.props;
        if ((0, $5uXOq.Children).count(children) === 0) return null;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9hBKJ.default), {
            listId: localId,
            children: children
        });
    }
}

});
parcelRegister("9hBKJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ba994f46a76f915$export$2e2bcd8739ae039);
/* TaskList.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $1PVpv = parcelRequire("1PVpv");

var $VSDnB = parcelRequire("VSDnB");

var $dJCKd = parcelRequire("dJCKd");

var $koVbs = parcelRequire("koVbs");
const $2ba994f46a76f915$var$listStyles = null;
const $2ba994f46a76f915$var$taskListStyles = null;
const $2ba994f46a76f915$var$TaskListNew = ({ listId: listId, children: children })=>{
    const listSize = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.count(children);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (!children) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "group",
        "data-task-list-local-id": "",
        "aria-label": formatMessage((0, $dJCKd.messages).fieldsetLabel),
        className: (0, $bwpsq.default)([
            "_2mzuglyw _19bvidpf"
        ]),
        children: (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(children, (child, idx)=>{
            const { localId: localId } = child.props;
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1PVpv.FabricElementsAnalyticsContext), {
                data: {
                    listLocalId: listId,
                    listSize: listSize,
                    position: idx
                },
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    "data-task-local-id": localId || '',
                    className: (0, $bwpsq.default)([
                        "_19pk1b66"
                    ]),
                    children: child
                }, idx)
            });
        })
    });
};
class $2ba994f46a76f915$var$TaskListOld extends (0, $5uXOq.PureComponent) {
    render() {
        const { listId: listId, children: children } = this.props;
        const listSize = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.count(children);
        if (!children) return null;
        // Data attributes are required for copy and paste from rendered content
        // to the editor to preserve the task.
        // This allows the editor to differentiate between numbered and ordered lists,
        // and action items, which all share the common `<li>` element.
        // The value of `data-task-local-id` should be discarded upon paste, with a
        // a new uuid generated by the editor for the cloned content.
        return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            "data-task-list-local-id": "",
            className: (0, $bwpsq.default)([
                "_2mzuglyw _19bvidpf"
            ]),
            children: (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(children, (child, idx)=>{
                const { localId: localId } = child.props;
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1PVpv.FabricElementsAnalyticsContext), {
                    data: {
                        listLocalId: listId,
                        listSize: listSize,
                        position: idx
                    },
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        "data-task-local-id": localId || '',
                        className: (0, $bwpsq.default)([
                            "_19pk1b66"
                        ]),
                        children: child
                    }, idx)
                });
            })
        });
    }
}
const $2ba994f46a76f915$var$TaskListNext = (props)=>{
    if ((0, $VSDnB.fg)('editor_a11y_group_around_action_items')) return /*#__PURE__*/ (0, $2OMIu.jsx)($2ba994f46a76f915$var$TaskListNew, {
        ...props
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)($2ba994f46a76f915$var$TaskListOld, {
        ...props
    });
};
var $2ba994f46a76f915$export$2e2bcd8739ae039 = $2ba994f46a76f915$var$TaskListNext;

});
parcelRegister("dJCKd", function(module, exports) {

$parcel$export(module.exports, "messages", () => $801c3c6b70f5a1d3$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $801c3c6b70f5a1d3$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    fieldsetLabel: {
        id: 'fabric.editor.fieldsetLabel',
        defaultMessage: 'Action Item List',
        description: 'Label for a list of tasks/ action items'
    }
});

});




//# sourceMappingURL=@atlaskit-internal_renderer-node_TaskList.e3b40680.js.map
